module.exports = __webpack_public_path__ + "img/ex_threeOfKinds.294f39fe.png";